module.exports = __webpack_public_path__ + "3b61bf12fb387250207d034e2297b22f.MP3";